// extracted by mini-css-extract-plugin
export default {"editorWrapper":"CoveringLetter_editorWrapper__dnwR+","editorToolbar":"CoveringLetter_editorToolbar__G6F7s","editor":"CoveringLetter_editor__HSxQV"};